/*eslint-disable*/
import Vue from 'vue';
import ElementUI from 'element-ui';
import { Lazyload } from 'vant';
import _axios from '@/lib/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import 'amfe-flexible';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

Vue.use(ElementUI);

import {
	getUrlKey,
} from '@/lib/util';

Vue.use(Lazyload);

// VConsole
// import VConsole from 'vconsole';
if (process.env.NODE_ENV === 'development') {
	// new VConsole();
}

// MOCK
// require('./mock');

Vue.config.productionTip = false;
Vue.prototype.$axios = _axios;

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	if (to.name === 'Login' || localStorage.getItem('Authorization')) {
		next();
	} else {
		next();
		// router.push({ path: '/login' });
	}
});
// eslint-disable-next-line no-unused-vars
router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
